<template>
    <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="8" cols="12">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <b-col lg="2" v-if="$route.params.id != '_new'">
          <b-link href="javascript:void(0)" @click="viewDocumentMilestones" class="float-right" style="color:#2dce89;">
            <i class="fa fa-anchor mr-2"></i>
            {{language_terms['MILESTONES']}}
          </b-link>
        </b-col>
      </b-row>
    </base-header>
    <!--Main Container-->
     <b-container fluid class="mt--6 container-padding">
        <div>
            <loading :active.sync="isLoading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        </div>
         <b-row>
             <b-col cols="12">
                  <div class="card-wrapper">
                      <card>
                          <div slot="header" class="mb-0">
                              <b-row>
                                <b-col lg="12">
                                  <div>
                                      <span style="font-weight: bold">{{ document_title }} </span>
                                  </div>
                                  <!-- <div>
                                    <printDocument :data="purchase_document" class="float-right" v-if="($route.params.id != '_new') && (purchase_document.status != 'PENDING_APPROVAL')"></printDocument> 
                                  </div>   -->
                                  <!-- <base-button icon type="success" class="float-right mr-5" @click="editDocument"  v-if="(is_edit == 0) && (document_mode != 'approval')">
                                      <i class="fas fa-edit"></i>
                                  </base-button> -->
                                  <b-dropdown :text="language_terms['VIEW_REVISIONS']" class="float-right mr-5" v-if=" (document_mode != 'approval') " variant="primary" >
                                    <div v-for="(revision, index) in revisions" :key="index">
                                      <b-dropdown-item v-if="revision.is_current == 0" @click="viewRevisionDoc(revision)">
                                          <span v-if="revision.revision != 0">{{language_terms['REVISION']}} {{revision.revision}} - {{revision.time_created}}</span>
                                          <span v-else>{{language_terms['ORIGINAL']}} - {{revision.time_created}}</span>
                                        </b-dropdown-item>
                                        <!-- {{revision.is_current}} -->
                                        <b-dropdown-divider v-if="revision.is_current == 1" ></b-dropdown-divider>
                                        <b-dropdown-item style="background-color:#c3e6cb" active v-if="revision.is_current == 1" @click="viewRevisionDoc(revision)">
                                          {{language_terms['CURRENT']}} - {{revision.time_created}} 
                                        </b-dropdown-item>
                                    </div>
                                  </b-dropdown>
                                </b-col>
                              </b-row>
                          </div>
                          <b-row>
                            <b-col :md="business_units.length > 1 ? 4 : 6">
                              <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                              <base-input v-model="purchase_document.contact_name" v-if="!is_edit" disabled></base-input>
                                <multiselect
                                  :internalSearch = "false"
                                  v-if="is_edit"
                                  v-model="purchase_document.vendor"
                                  id="ajax"
                                  label="name"
                                  track-by="id"
                                  placeholder="Type to search"
                                  open-direction="bottom"
                                  :options="vendors"
                                  :multiple="false"
                                  :searchable="true"
                                  :clear-on-select="false"
                                  :close-on-select="true"
                                  :options-limit="300"
                                  :limit="50"
                                  :max-height="600"
                                  :show-no-results="false"
                                  :hide-selected="false"
                                  @search-change="asyncFindVendor"
                                  @input="onSelectVendor"
                                >
                                </multiselect>
                            </b-col>
                            <b-col :md="business_units.length > 1 ? 2 : 3">
                              <base-input :label="language_terms['SUBTYPES']">
                                    <el-select
                                        v-model="purchase_document.subtype"
                                        filterable
                                        :placeholder="language_terms['SUBTYPES']"
                                        :disabled="!is_edit">
                                        <el-option
                                            v-for="option in purchase_subtypes"
                                            :key="option.subtype"
                                            :label="language_terms[option.subtype]"
                                            :value="option.subtype">
                                        </el-option>
                                    </el-select>
                              </base-input>
                            </b-col>
                            <b-col :md="business_units.length > 1 ? 2 : 3">
                              <base-input
                                :label="language_terms['ATTENTION']"
                                :placeholder="language_terms['ATTENTION']"
                                v-model="purchase_document.attention_to"
                                :disabled="!is_edit"
                              ></base-input>
                            </b-col>
                            <b-col md="4" v-if="business_units.length > 1">
                              <base-input :label="language_terms['BUSINESS_UNIT']">
                                <el-select
                                  v-model="purchase_document.businessunit_contact_id"
                                  filterable
                                  :placeholder="language_terms['BUSINESS_UNIT']"
                                  :disabled="!is_edit">
                                  <el-option
                                    v-for="option in business_units"
                                    :key="option.id"
                                    :label="option.name"
                                    :value="option.id">
                                  </el-option>
                                </el-select>
                              </base-input>
                            </b-col>
                          </b-row>
                          <b-row class="mt-4">
                              <b-col md="2">
                                <base-input
                                  :label="language_terms['REFERENCE']"
                                  :placeholder="language_terms['REFERENCE']"
                                  v-model="purchase_document.reference"
                                  :disabled="!is_edit"
                                ></base-input>
                              </b-col>
                              <b-col md="4">
                                <base-input :label="language_terms['DATE']" v-if="is_edit">
                                  <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    @on-change="onChangeDate"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="purchase_document.date">
                                  </flat-picker>
                                </base-input>
                                  <base-input
                                    :label="language_terms['DATE']"
                                    v-model="purchase_document.date"
                                    v-if="!is_edit"
                                    type="date"
                                    disabled
                                  ></base-input>
                              </b-col>
                              <b-col md="2">
                                <base-input
                                  :label="language_terms['VALIDITY_DAY']"
                                  :placeholder="language_terms['VALIDITY_DAY']"
                                  v-model="purchase_document.due_days"
                                  type="number"
                                  @change="onChangeValidityDays"
                                  :disabled="!is_edit"
                                ></base-input>
                              </b-col>
                              <b-col md="4">
                                <base-input :label="language_terms['DUE_DATE']"  v-if="is_edit">
                                  <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    :disabled="!is_edit"
                                    class="form-control datepicker"
                                    v-model="purchase_document.due_date"
                                  >
                                  </flat-picker>
                                </base-input>
                                <base-input
                                  :label="language_terms['DATE']"
                                  v-model="purchase_document.due_date"
                                  v-if="!is_edit"
                                  type="date"
                                  disabled>
                                </base-input>
                              </b-col>
                              <b-col md="2">
                              <base-input :label="language_terms['CURRENCY']">
                                  <el-select
                                    v-model="purchase_document.currency_code"
                                    filterable
                                    :placeholder="language_terms['CURRENCY']"
                                    disabled>
                                    <el-option
                                      v-for="option in currencies"
                                      :key="option.id"
                                      :label="option.code + ' (' + option.prefix + ')'"
                                      :value="option.code">
                                    </el-option>
                                  </el-select>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['TAX_CODE']">
                                <el-select
                                  disabled
                                  v-model="purchase_document.tax_code"
                                  filterable
                                  :placeholder="language_terms['TAX_CODE']"
                                  >
                                  <el-option
                                    v-for="option in taxes"
                                    :key="option.code"
                                    :label="option.code"
                                    :value="option.code">
                                  </el-option>
                                </el-select>
                              </base-input>
                            </b-col>
                            <b-col :md="($route.params.id != '_new') ? 2: 4">
                              <base-input :label="language_terms['AVAILABLE_CREDIT_LIMIT']" v-model="purchase_document.vendoe_credit_limit_available" disabled></base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['CREDIT_LIMIT']" v-model="purchase_document.vendor_credit_limit" disabled></base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['CREDIT_TERMS']" v-model="purchase_document.vendors_credit_term" disabled></base-input>
                            </b-col>
                            <b-col md="2" v-if="$route.params.id != '_new'">
                            <!-- {{language_terms[purchase_document.status]}} -->
                            <base-input :label="language_terms['STATUS']" :value="language_terms[purchase_document.status]" disabled></base-input>
                          </b-col>
                          </b-row>
                          <b-row>
                            <b-col md="6">
                              <base-input :label="language_terms['REMARKS']">
                                <textarea
                                  class="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows="3"
                                  v-model="purchase_document.remarks"
                                  :disabled="!is_edit"
                                ></textarea>
                              </base-input>
                            </b-col>
                            <b-col md="6">
                              <base-input :label="language_terms['INTERNAL_REMARKS']">
                                <textarea
                                  class="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows="3"
                                  :disabled="!is_edit"
                                  v-model="purchase_document.remarks_internal"
                                ></textarea>
                              </base-input>
                            </b-col>
                          </b-row>
                      </card>
                  </div>
             </b-col>
         </b-row>
         <b-row v-if="purchase_document.contact_id">
           <b-col cols="12">
              <div class="card-wrapper">
                <card>
                    <div slot="header" class="mb-0">
                      <h3>{{ language_terms["PURCHASE_ITEMS"] }}</h3>
                    </div>
                    <b-row  v-if="is_edit">
                      <b-col md="12" v-for="(item, index) in purchase_document.items" :key="index">
                         <b-card>
                            <b-row>
                              <b-col lg="5">
                                  <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                  <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event, index)" :lookupId="item.product_code"/>
                              </b-col>
                              <b-col lg="2" class="mb-3">
                                <base-input :label="language_terms['QTY']" v-model="item.qty" type="number"  :disabled="!is_edit" @change="onChangeField(item, index)"></base-input>
                              </b-col>
                              <b-col lg="1" class="mb-3">
                                <base-input :label="language_terms['UOM']" >
                                    <el-select v-model="item.uom" filterable @change="onChangeField(item, index)">
                                        <el-option v-for="option in item.uom_list"
                                                :key="option.code"
                                                :label="option.code"
                                                :value="option.code">
                                        </el-option>
                                    </el-select>
                                </base-input>
                              </b-col>
                              <b-col lg="3" class="mb-3">
                                <base-input :label="language_terms['UNIT_PRICE']" :placeholder="item.unit_price_placeholder" v-model="item.unit_price" type="number" min="0" :disabled="!is_edit" @change="onChangeField(item, index)" v-on:keyup.enter="addPurchaseItems"></base-input>
                              </b-col>
                              <b-col lg="1" class="mt-4 float-right">
                                <base-button @click="handleDelete(index, item)" size="sm" icon type="danger" class="mt-3"><i class="fas fa-trash-alt"></i ></base-button>
                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="mt-3"><i class="fa fa-angle-down"></i></base-button>
                              </b-col>
                              <b-col lg="12" v-if="item.is_trade == '1'">
                                  <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                  <multiselect
                                        v-model="item.trade_item"
                                        label="product_name"
                                        track-by="product_name"
                                        placeholder="Type to search"
                                        open-direction="bottom"
                                        :options="tradeitem_desp_list"
                                        :multiple="false"
                                        :searchable="true"
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :options-limit="300"
                                        :limit="50"
                                        :max-height="600"
                                        :show-no-results="false"
                                        :hide-selected="true"
                                        @search-change="asyncFindTradeItemDesp($event, index)"
                                        :internalSearch = "false"
                                        :taggable="true"
                                        @tag="addTag($event, index)"
                                        @select="onSelectTradeItemDesp($event, index)"
                                      >
                                  </multiselect>
                            </b-col>
                            </b-row>
                            <b-collapse v-model="item.is_collapsed">
                              <b-row class="mb-3">
                                <b-col lg="11"  v-if="item.is_trade == '0'">
                                  <base-input :placeholder="item.name" v-model="item.product_name" type="text" :disabled="!is_edit" :label="language_terms['PRODUCT_DESP']"></base-input>
                                </b-col>
                                <b-col lg="1" class="mt-4">
                                  <b-form-checkbox class="mt-3" v-model="item.has_memo" value="1" unchecked-value="0" :disabled="!is_edit" @change="toggleMemo(item.has_memo, index)">
                                      {{language_terms['MEMO']}}
                                  </b-form-checkbox>
                                </b-col>
                                <b-col lg="12" v-if="item.has_memo == 1">
                                  <base-input >
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="item.product_remarks" :disabled="!is_edit"></textarea>
                                  </base-input>
                                </b-col>
                              </b-row>
                              <b-row>
                                  <b-col lg="12">
                                      <base-input :label="language_terms['AMOUNT']" v-model="item.gross_amount" type="number" min="0" disabled></base-input>
                                  </b-col>
                              </b-row>
                            </b-collapse>
                         </b-card>
                      </b-col>

                    </b-row>
                    <b-row v-else>
                        <b-col sm="12">
                            <b-table-simple striped hover responsive>
                                <b-thead head-variant="light">
                                  <tr>  
                                      <th>{{language_terms['SNO']}}</th>
                                      <th>{{language_terms['PRODUCT_CODE']}}</th>
                                      <th>{{language_terms['PRODUCT']}}</th>
                                      <th>{{language_terms['QTY']}}</th>
                                      <th>{{language_terms['UOM']}}</th>
                                      <!-- <th>{{language_terms['LIST_PRICE']}}</th> -->
                                      <th>{{language_terms['UNIT_PRICE']}}</th>
                                      <th>{{language_terms['AMOUNT']}}</th>
                                      <!-- <th>{{language_terms['TAX_AMOUNT']}}</th> -->
                                      <!-- <th>{{language_terms['NETT_AMOUNT']}}</th> -->
                                  </tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="(row, index) in purchase_document.items" :key="index">
                                      <td width="20px">{{ row.sno }}</td>
                                      <td>{{row.product_code}}</td>
                                      <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                      <td>{{row.qty}}</td>
                                      <td>{{row.uom}}</td>
                                      <!-- <td>{{row.sale_list_price ? row.sale_list_price : '-'}}</td> -->
                                      <td>{{row.unit_price}}</td>
                                      <td>{{row.gross_amount}}</td>
                                      <!-- <td>{{row.tax_amount}}</td> -->
                                      <!-- <td>{{row.nett_amount}}</td> -->
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                </card>
              </div>
           </b-col>
         </b-row>
             <!-- Show Milestone Modal-->
     <b-modal v-model="milestones_modal" :header-bg-variant="'success'"  centered class="my-modal" hide-footer size="xl">
        <template #modal-title>
            <span style="color: white">{{language_terms['MILESTONES']}}</span>
        </template>
        <b-row>
          <b-col cols="12" v-if="milestones.length > 0">
            <ul class="timeline">
              <li v-for="(milestone, index) in milestones" :key="index" :class="getMilestoneClass(milestone)">
                <a href="javascript:void(0)" :style="getMilestoneTxtStyle(milestone)">{{language_terms[milestone.status]}}</a>
                <span class="float-right">{{milestone.time_created}}</span>
                <p>{{milestone.user_name}}</p>
              </li>
            </ul>
          </b-col>
          <b-col sm="12" v-else>
              <div align="center">{{language_terms['NO_DATA_AVAILABLE']}}</div>
          </b-col>
        </b-row>
        
     </b-modal>
        <!-- <b-row>
            <a href="javascript:void(0)" class="float-button2 mr-9" @click="addPurchaseItems" v-if="((purchase_document.contact_id != null && purchase_document.contact_id != '') && is_edit)" >
              <i class="fas fa-plus my-float-button"></i>
            </a>
        </b-row> -->
     </b-container>
      <div class="floating-bar">
        <div class="floating-bar-container" align="center">
            <b-button-group>
              <b-button class="transparent-btn" @click="addPurchaseItems"  v-if="((purchase_document.contact_id != null && purchase_document.contact_id != '') && is_edit)">
                <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
              </b-button>
              <b-button class="transparent-btn" @click="editDocument"  v-if="(is_edit == 0) && (document_mode != 'approval')">
                <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
              </b-button>
              <!-- <b-dropdown right v-if=" (document_mode != 'approval')" class="transparent-btn">
                <template #button-content>
                  <b-icon icon="three-dots-vertical" class="text-warning"></b-icon>
                  {{language_terms['VIEW_REVISIONS']}}
                </template>

                <div v-for="(revision, index) in revisions" :key="index" >
                  <b-dropdown-item v-if="revision.is_current == 0" @click="viewRevisionDoc(revision)">
                      <span v-if="revision.revision != 0">{{language_terms['REVISION']}} {{revision.revision}} - {{revision.time_created}}</span>
                      <span v-else>{{language_terms['ORIGINAL']}} - {{revision.time_created}}</span>
                    </b-dropdown-item>
                    <b-dropdown-divider v-if="revision.is_current == 1" ></b-dropdown-divider>
                    <b-dropdown-item style="background-color:#c3e6cb" active v-if="revision.is_current == 1" @click="viewRevisionDoc(revision)">
                      {{language_terms['CURRENT']}} - {{revision.time_created}} 
                    </b-dropdown-item>
                </div>  
              </b-dropdown> -->
              <printDocument :data="purchase_document" v-if="($route.params.id != '_new') && (purchase_document.status != 'PENDING_APPROVAL')"></printDocument> 
              <b-button class="transparent-btn" @click="saveDocument" v-if="is_edit">
                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}} 
              </b-button>
              <b-button class="transparent-btn" @click="cancelDocument" v-if="is_edit">
                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
              </b-button>
            </b-button-group>
        </div>
      </div>
    <!--Floating Button-->
    <!-- <div style="width:100%;">
        <a href="javascript:void(0)" class="float-button" @click="cancelDocument" v-if="is_edit" style="background-color:#fb6340">
          <i class="fa fa-times my-float-button"></i>
        </a>
        <a href="javascript:void(0)" class="float-button marginCheck" @click="saveDocument" v-if="is_edit" style="background-color:#5e72e4">
          <i class="fas fa-check my-float-button"></i>
        </a>
    </div> -->
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";
import printDocument from "../Components/printPdf.vue"

export default {
    props: {
      type: {
        type: String,
        default: "PO",
        description: "Purchase Type",
        required: true,
      },
      title: {
        type: String,
        default: "",
        description: "Purchase Document Title",
        required: true,
      }
    },
    components: { 
          Loading,
          [Select.name]: Select,
          [Option.name]: Option,
          [Dropdown.name]: Dropdown,
          [DropdownMenu.name]: DropdownMenu,
          [DropdownItem.name]: DropdownItem,
          flatPicker,
          [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          productLookup,
          printDocument
     },
    computed:{
    ...mapState({
        purchase_doc: (state) => state.purchase.document,
        language_terms: state => state.languages.language_terms,
        business_units: (state) => state.vendors.business_units,
        currencies: (state) => state.currencies.currencies,
        taxes: (state) => state.taxes.taxes,
        taxData: (state) => state.taxes.data,
        uom_list:state => state.products.uom_list, 
        product_price: (state) => state.products.product_purchase_price,
        purchase_is_created: (state) => state.purchase.is_created,
        purchase_is_updated: (state) => state.purchase.is_updated,
        purchase_filter:state => state.purchase.filter,
        milestones: state => state.documentMilestones.milestones,
        revisions: state => state.documentRevisions.revisions, 
        revision_is_created: state => state.documentRevisions.revision_created,
        revision_is_retrieved: state => state.documentRevisions.is_retrieved,
        revision_data: state => state.documentRevisions.data,
        purchase_subtypes:state => state.purchase.purchase_subtypes
      }),
    },
    data(){
        return{
            document_mode:null,      
            milestones_modal:false,
            isLoading:false,
            document_title:"",
            is_edit:false,
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP_FOR_PURCHASE"],
            vendors:[],
            desp_tags:[],
            tradeitem_desp_list:[],
            selected_business_unit:{id:""},
            purchase_document: {
                subtype:"NORMAL_PURCHASE",
                revision_json:{},
                revision_id:null,
                time_printed:null,
                delivery_eta_days:null,
                action_edit:0,
                action_approval:0,
                require_approval:0,
                salesperson_contact_id:null,
                businessunit_contact_id:null,
                vendor_credit_term:null,
                vendor_credit_limit:null,
                vendor_credit_limit_available:null,
                is_locked: false,
                is_approved: null,
                due_days: 30,
                due_date: null,
                tax_code: "",
                tax_rate_percent: null,
                contact_id: null,
                vendor: {},
                currency_code: "SGD",
                remarks:"",
                remarks_internal:"",
                items: [
                  {
                    sno: 1,
                    is_trade:0,
                    is_collaspe:false,
                    reservation_max_days:null,
                    trade_item:{},
                    uom:"",
                    uom_list:[],
                    product:{id:"", code:"", name:""},
                    bom_components:[],
                    product_id: "",
                    product_name: "",
                    qty: "",
                    has_memo:"0",
                    product_remarks:"",
                    moq:"",
                    unit_price: "",
                    discount_amount: "",
                    tax_amount: "",
                    gross_amount: "",
                  },
                  {
                    sno: 2,
                    is_trade:0,
                    is_collaspe:false,
                    reservation_max_days:null,
                    trade_item:{},
                    uom:"",
                    uom_list:[],
                    product:{id:"", code:"", name:""},
                    bom_components:[],
                    product_id: "",
                    product_name: "",
                    qty: "",
                    has_memo:"0",
                    product_remarks:"",
                    moq:"",
                    unit_price: "",
                    discount_amount: "",
                    tax_amount: "",
                    gross_amount: "",
                  },
                  {
                    sno: 3,
                    is_trade:0,
                    is_collaspe:false,
                    reservation_max_days:null,
                    trade_item:{},
                    uom:"",
                    uom_list:[],
                    product:{id:"", code:"", name:""},
                    bom_components:[],
                    product_id: "",
                    product_name: "",
                    qty: "",
                    has_memo:"0",
                    product_remarks:"",
                    moq:"",
                    unit_price: "",
                    discount_amount: "",
                    tax_amount: "",
                    gross_amount: "",
                  }
                ],
                type: null,
      },
        }
    },
    methods:
    {

    async viewRevisionDoc(revision)
    {
      this.loading = true
      this.revison_modal = false

      if(revision)
      {
        let doc = revision.data_json

        await this.$store.dispatch("documentRevisions/fetch", {revision_id: revision.id});

        if(this.revision_is_retrieved)
        {
            let documnet_id = `${doc.code} - ${this.language_terms['REVISION']} ${revision.revision}`
            this.document_title = `${this.$props.title} (${documnet_id})`;

            if(revision.is_current == 1)
            {
                this.is_view_revision = 0
                await this.retrieveDocument(doc.code, this.type)
            }
            else
            {
                this.is_view_revision = 1;
                doc.revision_id = revision.id;
                this.purchase_document = this.revision_data.data_json;
            }
            
          await this.asyncFindVendor(this.purchase_doc.contact_code);
          let selected_vendor = 
          {
            id: this.purchase_document.contact_id,
            code: this.purchase_document.contact_code,
            name: this.purchase_document.contact_name,
            customer_tax_code: this.purchase_document.contact_customer_tax_code,
          };

          this.purchase_document.customer = selected_vendor;

          if(this.purchase_document.is_approved == 1) 
          {
            this.purchase_document.is_locked = true;
          }
          let vm = this
          this.purchase_document.items.forEach(function (element, index) {
                element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
                element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
                if(element.is_trade == 1)
                {
                    vm.addTag(element.product_name, index)
                }
          });

        }


      }

      this.loading = false
    },
  
      editDocument()
      {
        this.is_edit = true
      },
      async retrieveDocument(code, type) {
          await this.$store.dispatch("purchase/fetch", {
            code: code,
            type: type,
          });

          this.purchase_document = this.purchase_doc;
      },
      async asyncFindTradeItemDesp (query, index) 
      {
          let product_id = this.purchase_document.items[index].product_id
          let pv = { value: query, contact_id:this.purchase_document.contact_id, date:"", product_id: product_id};
          axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.tradeitem_desp_list = response.data.data
              Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
              this.tradeitem_desp_list = []
            }
          })
          .catch((error) => 
          {
            if (error.response) 
            {
              Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
              });
            } 
            else 
            {
              console.log("Problem Querying Data", error);
            }
          });
    },
    onSelectTradeItemDesp(selectedOption, index)
    {
        if(selectedOption)
        {
          let item = this.purchase_document.items[index]
          item.product_name = selectedOption.product_name
          this.$set(this.purchase_document.items, index , item) 
        }
    },
        getMilestoneTxtStyle(milestone)
    {
        let style = "color:red;font-weight:bold;"

        if(milestone.status == 'OPEN')
        {
          style = "color:#22c0e8;font-weight:bold;"
        }
        else if(milestone.status == 'PENDING_APPROVAL')
        {
          style = "color:#ffc107;font-weight:bold;"
        }
        else if(milestone.status == 'APPROVED')
        {
          style = "color:#2dce89;font-weight:bold;"
        }
        else if(milestone.status == 'REVISED')
        {
          style = "color:#5603ad;font-weight:bold;"
        }

        return style
    },
        getMilestoneClass(milestone)
    {
        let classname = 'statusopen';

        if(milestone.status == 'OPEN')
        {
          classname = 'statusopen';
        }
        else if(milestone.status == 'PENDING_APPROVAL')
        {
          classname = 'statuspendingapproval';
        }
        else if(milestone.status == 'APPROVED')
        {
          classname = "statusapproved"
        }
        else if(milestone.status == 'REJECTED')
        {
          classname = "statusrejected"
        }
        else if(milestone.status == 'REVISED')
        {
          classname = "statusrevised"
        }
        return classname
    },
    isFoundInList(name)
    {
        let is_found = 0
        for(let i = 0; i < this.desp_tags.length; i++)
        {
            if(this.desp_tags[i].product_name == name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    addTag(newTag, index)
    {
      if(newTag)
      {
        let obj = {product_name: newTag, contact_id:this.purchase_document.contact_id, date:this.purchase_document.date}
        if(this.isFoundInList(newTag) == 0)
        {
            this.desp_tags.push(obj)

            console.log(this.tradeitem_desp_list)

            Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 


            this.purchase_document.items[index].trade_item = obj
            this.purchase_document.items[index].product_name = newTag

        }

      }
    },
      handleCollaspe(index, row)
      {
          if(row.is_collapsed)
          {
            row.is_collapsed = false
          }
          else
          {
            row.is_collapsed = true
          }


          this.$set(this.purchase_document.items, index , row) 
      },
      handleDelete(index, row) 
      {
        this.purchase_document.items.splice(index, 1);
      },
      addPurchaseItems() 
      {
        let purchase_items_length = this.purchase_document.items.length;

          let item = {
            sno: purchase_items_length + 1,
            is_trade:0,
            product:{id:"", code:"", name:""},
            uom:"",
            product_id: "",
            product_name: "",
            qty: "",
            has_memo:"0",
            product_remarks:"",
            sale_list_price:"",
            moq:"",
            unit_price: "",
            discount_amount: "",
            tax_amount: "",
            gross_amount: "",
            uom_list:[],
            is_collapsed:false,
            trade_item:{}
          };

        this.purchase_document.items.push(item);
      },
        async onChangeDate() 
        {
          if (this.purchase_document.date) 
          {
            if (this.purchase_document.tax_code)
            {
              await this.retrieveRate(this.purchase_document.tax_code,this.purchase_document.date);
              this.purchase_document.tax_rate_percent = this.taxData.rate_percent
            }

            this.onChangeValidityDays();
          }
        },
        async onChangeValidityDays() 
        {
          this.purchase_document.due_date = moment(this.purchase_document.date).add(this.purchase_document.due_days, "days").format("YYYY-MM-DD");
        },
        async onChangeField(row, index)
        {
          if((row.qty || row.unit_price) && row.product_id)
          {
              let unit_price = row.unit_price * 1;

              let product_id = row.product_id
              let qty = row.qty * 1;
              let uom = row.uom; 
              let product_price = await this.retrieveProductPrice(product_id, this.purchase_document.contact_id, qty, uom);

              
              this.purchase_document.items[index].unit_price_placeholder = isNaN(product_price.unit_price) ? 0 : (product_price.unit_price *1)

              if(product_price)
              {
                qty = product_price.qty * 1;
              }


              let gross_amount = product_price.total_amount;

              if(unit_price)
              {
                  gross_amount = qty * unit_price;
              }
              this.purchase_document.items[index].qty = qty 
              this.purchase_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)

          }
        },
        async asyncFindVendor(query) 
        {
          let pv = { value: query };
          await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
              if (response.data.code == 1) {
                this.vendors = response.data.data;
              } else {
                this.vendors = [];
              }

              this.isLoading = false;
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response);
                Vue.notify({
                  group: "notify",
                  type: "error",
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300,
                });
              } else {
                console.log("Problem submitting New Post", error);
              }
            });
        },
        async onChangeBusinessUnit()
        {
          if(this.selected_business_unit.id)
          {
            this.purchase_document.contact_id = this.selected_business_unit.id;
            this.purchase_document.contact_code = this.selected_business_unit.code
            this.purchase_document.contact_name = this.selected_business_unit.name

            this.purchase_document.tax_code = this.selected_business_unit.vendor_tax_code;
            await this.onChangeTaxCode(this.selected_business_unit.vendor_tax_code);
          }
        },
        async onSelectVendor(selectedOption)
        {
            if(selectedOption)
            {
                if(selectedOption.id)
                {
                  this.selected_business_unit = {id:""}
                  await this.$store.dispatch("vendors/fetchBusinessUnits", {parent_id: selectedOption.id});
                  if(this.business_units.length > 1)
                  {
                      this.purchase_document.businessunit_contact_id = this.business_units[0].id
                      this.purchase_document.contact_id = selectedOption.id;
                  }
                  else
                  {
                      this.purchase_document.contact_id = selectedOption.id;
                      this.purchase_document.tax_code = selectedOption.vendor_tax_code;
                      this.purchase_document.currency_code = selectedOption.currency_code;
                      this.purchase_document.customer_credit_term = selectedOption.customer_credit_term;
                      this.purchase_document.customer_credit_limit = selectedOption.customer_credit_limit;
                      this.purchase_document.customer_credit_limit_available = selectedOption.customer_credit_limit_available;
                      this.purchase_document.attention_to = selectedOption.contact_person

                      await this.retrieveRate(this.purchase_document.tax_code, this.purchase_document.date)
                      this.purchase_document.tax_rate_percent = this.taxData.rate_percent
                  }

                }
            }
        },
        async viewDocumentMilestones()
        {
            await this.$store.dispatch("documentMilestones/fetchAll", {document_id:this.purchase_document.id})
            this.milestones_modal = true
        },
        async retrieveRate(code, date) 
        {
          await this.$store.dispatch("taxes/fetch", { code: code, date: date });
          this.purchase_document.tax_rate_percent = this.taxData.rate_percent;
        },
        async onChangeTaxCode() 
          {
            if (this.purchase_document.tax_code) 
            {
              await this.retrieveRate(
                this.purchase_document.tax_code,
                this.purchase_document.date
              );
              this.purchase_document.tax_rate_percent = this.taxData.rate_percent
            }
          },
        cancelDocument() 
        {
            if(this.$route.params.id == '_new')
            {
              this.routeToMaster()
            }
            else
            {
              location.reload();
            }        
        },
        routeToMaster() 
        {
          if (this.type == "PO") 
          {
            this.$router.push("/purchase/purchase-orders");
          } 
          else if (this.type == "PI") 
          {
            this.$router.push("/purchase/purchase-invoices");
          }
        },
        async saveDocument() 
        {
          if (this.$route.params.id == "_new") 
          {
            this.purchase_document.type = this.type;
            await this.$store.dispatch("purchase/create", this.purchase_document);

            if(this.purchase_is_created)
            {
              await this.searchPurchase();
              this.routeToMaster();
            }
          } 
          else 
          {
            this.purchase_document.type = this.type;
            
            if(this.purchase_document.time_printed || this.purchase_document.revision != 0 || this.purchase_document.is_approved != null)
            {
              await this.$store.dispatch("documentRevisions/create", this.purchase_document);

                if(this.revision_is_created == "1")
                {
                    await this.searchPurchase();
                    this.routeToMaster();
                }

            }
            else
            {
              await this.$store.dispatch("purchase/update", this.purchase_document);

              if(this.purchase_is_updated == "1")
              {
                  await this.searchPurchase();
                  this.routeToMaster();
              }
            }

          }
        },
        async reapplyPrices()
        {

        },
        async searchPurchase()
        {
              this.isLoading = true
              let filter = {
                              keyword:"",
                              date_from:null,
                              date_to:null,
                              type:this.purchase_document.type,
                              status:'ALL'
                            }
              if(this.purchase_filter)
              {
                  filter = this.purchase_filter
              }
              await this.$store.dispatch('purchase/quickSearch', filter)

              this.isLoading = false
          },
        fetchCurrencies() {
          this.$store.dispatch("currencies/fetchAll", {});
        },
        fetchTaxes() {
          this.$store.dispatch("taxes/fetchAll", { type: "Purchase" });
        },
        async getAuthUser()
        {
          await this.$store.dispatch("auth/getAuthUser", {})
        },
        async selectProduct(product, index)
        {
            let item = this.purchase_document.items[index]

            if(product.id)
            {
              let product_id = product.id
              let product_code = product.code
              let name = product.name
              let uom = product.uom
              let available_qty = product.available_qty
              let is_trade = product.is_trade

              this.purchase_document.items[index].name = name
              this.purchase_document.items[index].uom = uom
              this.purchase_document.items[index].available_qty = available_qty
              this.purchase_document.items[index].is_trade = is_trade

              // MOQ Display
              let moq = product.moq
              this.purchase_document.items[index].moq_display = (moq !='' && moq != null) ? moq: '-'

              let qty = (this.purchase_document.items[index].qty != '' && this.purchase_document.items[index].qty != null) ? (this.purchase_document.items[index].qty *1) : 0

              //qty = 100;

              // Retrieve UOM List
              let uom_list = await this.retrieveUomList(product_id)
              this.purchase_document.items[index].uom_list = uom_list

              let product_price = await this.retrieveProductPrice(product_id, this.purchase_document.contact_id, qty, uom);

              let unit_price  = this.purchase_document.items[index].unit_price 
              this.purchase_document.items[index].unit_price_placeholder =  isNaN(product_price.unit_price) ? 0 : (product_price.unit_price *1)

              let gross_amount = product_price.total_amount;


              if(unit_price)
              {
                gross_amount = qty * unit_price;
              }

              this.purchase_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)

              this.purchase_document.items[index].product_id = product_id
              this.purchase_document.items[index].product_code = product_code

              let row = this.purchase_document.items[index]
              this.$set(this.purchase_document.items, index , row) 
            }

        },
        async retrieveUomList(product_id)
        {
            let uom_list = []
            await this.$store.dispatch("products/listUoms", {product_id:product_id})
            if(this.uom_list.length > 0)
            {
                uom_list = this.uom_list
            }

            return uom_list
        },
        async retrieveProductPrice(product_id, vendor_id, qty, uom) 
        {

          await this.$store.dispatch("products/fetchProductPurchasePrice", {
            product_id: product_id,
            contact_id: vendor_id,
            date: this.purchase_document.date,
            qty:qty,
            currency_code: this.purchase_document.currency_code,
            uom:uom
          });


          return this.product_price;
        },
        async viewRevisions()
        {
          await this.$store.dispatch('documentRevisions/fetchAll', {document_id:this.purchase_document.id});

          //this.revison_modal = true

        }
    },
    async mounted()
    {
      this.isLoading = true
      let documnet_id = this.$route.params.id;

      await this.$store.dispatch("purchase/getPurchaseSubTypes", {})

      if(documnet_id == '_new')
      {
        this.document_title = "New " + this.$props.title;

        if(!this.purchase_document.date)
        {
          this.purchase_document.date = moment().format("YYYY-MM-DD");
        }

        this.purchase_document.due_date = moment(this.purchase_document.date).add(this.purchase_document.due_days, "days").format("YYYY-MM-DD");


        if(this.purchase_document.date && this.purchase_document.tax_code)
        {
          this.retrieveRate(this.purchase_document.tax_code, this.purchase_document.date)
          this.purchase_document.tax_rate_percent = this.taxData.rate_percent
        }
        this.is_edit = true
      }
      else
      {
          if (this.type && documnet_id) 
          {
            await this.retrieveDocument(documnet_id, this.type);
          }

          this.document_title = `${this.$props.title} (${documnet_id})`;
          
          await this.asyncFindVendor(this.purchase_doc.contact_code);

          let selected_vendor = {
            id: this.purchase_document.contact_id,
            code: this.purchase_document.contact_code,
            name: this.purchase_document.contact_name,
            vendor_tax_code: this.purchase_document.contact_vendor_tax_code,
          };

          this.purchase_document.vendor = selected_vendor;

          if(this.purchase_document.is_approved == 1) 
          {
            this.purchase_document.is_locked = true;
          }

          let vm = this
          this.purchase_document.items.forEach(function (element, index) {
                element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
                element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
                if(element.is_trade == 1)
                {
                    vm.addTag(element.product_name, index)
                }
          });
        await this.viewRevisions()
        this.is_edit = false
      }

      await this.fetchCurrencies();
      await this.fetchTaxes();
      await this.getAuthUser()

      this.isLoading = false
    }
}
</script>
<style scoped>



.marginCheck{
  margin-right:90px;
}
 .float-button2
  {
    position:fixed;
    width:60px;
    height:60px;
    bottom:40px;
    /* background-color:#0C9; */
    background-color:#2dce89;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px #999;
  }
/* .marginPlus{
  margin-right:220px;
} */

</style>